import { AuthPayloadInterface, DefaultEmbedConfig, EmbedCSS, EmbedConfig, From, MessageAuth, Slug } from "@swivl-mono/types";
import React from "react";

import { Config } from "./Config/Config";
import { Form } from "./Form/Form";
import { List } from "./List/List";
import ListWrapper from "./List/ListWrapper/ListWrapper";
import { Modal } from "./Modals/Modal";
import "./SwivlChat.scss";
import { CommandHandler } from "./command/CommandHandler";
import SwivlChatInterface from "./interface/SwivlChatInterface";
import SwivlChatProps from "./interface/SwivlChatProps";
import SwivlChatState from "./interface/SwivlChatState";
import { MessageHandler } from "./messages/MessageHandler";
import { SocketHandler } from "./sockets/SocketHandler";

export class SwivlChat extends React.Component<SwivlChatProps, SwivlChatState> implements SwivlChatInterface {
  // Socket Properties
  ref = React.createRef<HTMLDivElement>();

  // config:EmbedConfig;
  socketHandler: SocketHandler;
  messageHandler: MessageHandler;
  commandHandler: CommandHandler;
  hasStarted: boolean = false;

  list?: List;
  css?: any;
  isNewUser: boolean = false;

  // shouldStartOnConnect:boolean;
  constructor(props: SwivlChatProps) {
    super(props);
    console.log('props :', props);

    let auth;

    for (const key in DefaultEmbedConfig) {
      if (Object.prototype.hasOwnProperty.call(DefaultEmbedConfig, key)) {
        (Config as any)[key] = DefaultEmbedConfig[key];
      }
    }

    Config.isReadOnly = props.isReadOnly || props.transcriptOnly;
    Config.canPressButtons = !props.canTakeOver && !Config.isReadOnly;
    Config.hideForm = props.hideForm || Config.isReadOnly;
    Config.hidePastMessages = props.hidePastMessages;



    if (Config) {
      for (const key in props.config) {
        if (Object.prototype.hasOwnProperty.call(props.config, key)) {
          if (key === "name") {
            //skip name
          } else {
            (Config as any)[key] = props.config[key];
            console.log(`Config.${key} =`, props.config[key]);
          }
        }
      }
    }
    if (props.auth) {
      auth = this.props.auth;
      this.isNewUser = false;
      if (auth.token && auth.token.length < 100) {
        console.warn("SwivlChat: Auth token is too short, users will need a new one", auth.token);
        auth = undefined;
        localStorage.removeItem("swivl_auth_" + Config.orgId);

      } else {
        if (localStorage && !props.canTakeOver && !this.props.transcriptOnly) {
          localStorage.setItem("swivl_auth_" + Config.orgId, JSON.stringify(auth));
        }
      }
    } else if (!this.props.transcriptOnly) {
      this.isNewUser = true;
      if (localStorage && localStorage.getItem("swivl_auth_" + Config.orgId)) {
        var ls_auth: MessageAuth = JSON.parse(localStorage.getItem("swivl_auth_" + Config.orgId)!);
        if (ls_auth) {
          this.isNewUser = false;
          if (ls_auth.userId && !props.canTakeOver) {
            ls_auth.from = From.USER;
            ls_auth.userId = ls_auth.userId;
            localStorage.setItem("swivl_auth_" + Config.orgId, JSON.stringify(ls_auth));
          }

          auth = ls_auth; // JSON.parse(localStorage.getItem("swivl_auth_" + Config.botId ));
        }
      }
    }
    if (this.props.channel && auth) {
      auth.channel = this.props.channel;
    }
    console.log(' this.state :', this.state);
    console.log(' this.props :', props);




    this.state = {
      auth: auth,
      hasStarted: false,
      isShowingModal: false,
      modalContent: undefined,
    };

    // Config = Config;

    if (this.props.generateCSS && Config && Config.orgId) {
      const css = EmbedCSS(Config as any, "#swivl_" + Config.orgId);
      this.css = css ? <style id="swivlCSS" dangerouslySetInnerHTML={{ __html: css }} /> : null;
    }
    // this.shouldStartOnConnect = (Config.startConversationClosed || !props.parentControlsStart || (props.parentControlsStart  &&  props.isOpen)) ? true : false;

    this.startConversation = this.startConversation.bind(this);
    this.onConnect = this.onConnect.bind(this);
    this.resetConversation = this.resetConversation.bind(this);

    this.socketHandler = new SocketHandler(this);
    this.messageHandler = new MessageHandler(this);
    this.commandHandler = new CommandHandler(this);

    this.triggerGoToQuest = this.triggerGoToQuest.bind(this);

    this.showModal = this.showModal.bind(this);
    this.hideModal = this.hideModal.bind(this);

    this.getUserAndAuth = this.getUserAndAuth.bind(this);
    this.updateAuth = this.updateAuth.bind(this);

    this.start = this.start.bind(this);

    // if (!auth && !this.props.transcriptOnly) {
    //   this.getUserAndAuth()
    //     .then((auth) => {
    //       if (auth) {
    //         this.updateAuth(auth);
    //         setTimeout(() => {
    //           this.start();
    //         }, 200);
    //       }
    //     })
    //     .catch((err) => {
    //       console.error("Error getting user and auth", err);
    //     });
    // }
  }

  clearAuthAndCreateNewUser() {
    console.log('TESTINGSEND clearAuthAndCreateNewUser :');
    if (Config.orgId && localStorage && !this.props.canTakeOver) {
      localStorage.removeItem("swivl_auth_" + Config.orgId);
    }
    this.setState({ auth: undefined, hasStarted: false });
    this.isNewUser = true;
    this.getUserAndAuth()
      .then((auth) => {
        if (auth) {
          this.updateAuth(auth);
          setTimeout(() => {
            this.start();
          }, 200);
        }
      })
      .catch((err) => {
        console.error("Error getting user and auth", err);
      });
  }

  componentDidMount() {
    if (this.props.isOpen || Config.startConversationClosed) {

      this.start();
    }
  }


  start() {
    console.log('SwivlChat start', { orgId: Config.orgId, server: this.props.server, auth: this.state.auth });
    if (!this.props.server) {
      console.error("SwivlChat cannot start. Missing orgId, server or auth",
        { orgId: Config.orgId, server: this.props.server, auth: this.state.auth });


      return;
    }
    if (!this.props.canTakeOver && !this.state.auth && !this.props.transcriptOnly) {
      return this.getUserAndAuth()
        .then((auth) => {
          if (auth) {
            this.updateAuth(auth);
            setTimeout(() => {
              this.start();
            }, 200);
          }
        })
        .catch((err) => {
          console.error("Error getting user and auth", err);
        });
    }




    if (this.props.preloadedMessages) {
      this.list?.addMessagesToList(this.props.preloadedMessages);
    }

    if (this.props.isOpen || Config.startConversationClosed) {
      if (this.props.transcriptOnly) {
        this.list?.loadTranscript(this.props.transcriptDate!);
        console.log("SwivlChat transcriptOnly mode, loaded transcript");
        return;
      }

      if (this.props.loadPastMessagesBeforeConnect) {
        this.list?.loadPastMessages();
      }
      this.socketHandler.connect();
    }
    console.log("SwivlChat started", { orgId: Config.orgId, server: this.props.server, auth: this.state.auth })
  }


  onConnect() {
    // if (this.shouldStartOnConnect) {

    this.startConversation();
    // }
    /** if the sender is an agent and we are not doing a start conversation, we still need to register them with their token */
    if (this.state.auth && (this.state.auth.from === From.BOT || this.state.auth.from === From.AGENT)) {
      this.messageHandler.sendAuthMessage();
    }
    if (this.props.onConnectionOpened) {
      this.props.onConnectionOpened();
    }
  }

  /** Check to see if we the open state changed in this method.*/
  getSnapshotBeforeUpdate(prevProps: any, prevState: any) {
    if ((!prevProps.isOpen && this.props.isOpen) || (prevProps.isOpen && !this.props.isOpen)) {
      return { openPropChanged: true };
    }
    return null;
  }
  componentDidUpdate(prevProps: any, prevState: any, snapshot: any) {
    if (snapshot && snapshot.openPropChanged && !this.state.hasStarted && !snapshot.isTriggeringGoto) {
      // if (!Config.startConversationClosed) {
      this.start();

      // this.socketHandler.connect();
      // }

      // this.startConversation();
    }
  }

  startConversation() {
    if (this.props.transcriptOnly) {
      return;
    }

    if (this.state.auth && this.props.canTakeOver) {

      // If it is a possibile takeover, load messages
      this.list?.loadPastMessages();
    } else {
      if (this.state.auth) {
        if (Config.loadPastMessages) {
          this.list?.loadPastMessages();
        }

        this.messageHandler.sendStartConversation();
      } else {
        this.messageHandler.sendCreateUserAndStartConversation();
      }
    }
    this.setState({ hasStarted: true });
  }
  updateAuth(auth: AuthPayloadInterface) {
    console.log('TESTINGSEND updateAuth :', auth);
    if (!this.props.canTakeOver && (!auth.token || auth.token.length < 100)) {
      console.error("TESTINGSEND SwivlChat: Invalid auth token, users will need a new one", auth.token);
      setTimeout(() => {
        this.resetConversation();
      }, 1500);
      return;
    }
    console.log('TESTINGSEND updateAuth 2:', auth);
    if (!auth.channel && this.props.channel) {
      auth.channel = this.props.channel;
    }
    this.setState({ auth: auth });

    if (localStorage && !this.props.canTakeOver) {
      localStorage.setItem("swivl_auth_" + Config.orgId, JSON.stringify(auth));
    }
  }
  resetConversation() {
    this.list?.resetList();
    if (localStorage && !this.props.canTakeOver) {
      localStorage.removeItem("swivl_auth_" + Config.orgId);
    }
    this.setState({ auth: undefined, hasStarted: false });
    setTimeout(() => {
      this.startConversation();
    }, 200);
  }

  triggerGoToQuest(questSlug: Slug) {
    if (!this.state.hasStarted) {
      Config.startOnQuest = questSlug;
      if (Config.startConversationClosed) {
        this.startConversation();
      } else {
        this.socketHandler.connect();
      }
      return;
    }
    if (!this.state.auth) {
      return;
    }
    var xhr = new XMLHttpRequest();
    const url = "https://" + this.props.server + "/node_router/goto";
    xhr.open("POST", url, true);
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.send(JSON.stringify({ questSlug: questSlug, auth: this.state.auth }));
  }

  showModal(modalContent: React.ReactNode) {
    this.setState({ isShowingModal: true, modalContent: modalContent });
  }
  hideModal() {
    if (this.state.isShowingModal || this.state.modalContent) {
      this.setState({ isShowingModal: false, modalContent: undefined });
    }
  }

  componentWillUnmount(): void {
    this.socketHandler.disconnect();
  }

  getUserAndAuth() {
    console.log('TESTINGSEND :', this.state);


    function ensureHttpBase(urlOrHost: string): string {
      if (!urlOrHost) return "";
      if (urlOrHost.startsWith("http://") || urlOrHost.startsWith("https://")) return urlOrHost;
      // default to https for Messaging API calls
      return `https://${urlOrHost}`;
    }
    let orgId = Config.orgId;
    if (!orgId && this.state.auth?.orgId) {
      orgId = this.state.auth.orgId;
    }
    if (!orgId) {
      return Promise.reject("Missing orgId, cannot get user");
    }
    const URL = `${ensureHttpBase(this.props.server)}/api/users/new-user/${orgId}`;

    return fetch(URL).then((data) => {
      console.log('data :', data);
      return data.json();
    }).then((json) => {
      return json;
    }).catch((err) => {
      console.error("Error fetching user", err);
      return Promise.reject(err);
    });
  }


  render() {
    const form =
      Config.hideForm || this.props.transcriptOnly ? null : (
        <Form
          delegate={this}
          isConversationTakenOver={this.props.isConversationTakenOver ? true : false}
          canTakeoverViaSMS={this.props.canTakeoverViaSMS ? true : false}
        />
      );

    const width = this.ref && this.ref.current && this.ref.current.clientWidth ? this.ref.current.clientWidth : 300;
    const height = this.ref && this.ref.current && this.ref.current.clientHeight ? this.ref.current.clientHeight : 300;

    return (
      <div className={Config.hideForm ? "scc-noForm SwivlChat" : "SwivlChat"} id={"swivl_" + Config.orgId} ref={this.ref}>
        <Modal isShowing={this.state.isShowingModal} content={this.state.modalContent} hideModal={this.hideModal} />
        {this.css}
        <ListWrapper>
          <List
            delegate={this}
            auth={this.state.auth}
            isNewUser={this.isNewUser}
            hasStarted={this.state.hasStarted}
            isMobile={this.props.isMobile}
            isOpen={this.props.isOpen}
            isConversationTakenOver={this.props.isConversationTakenOver ? true : false}
            width={width}
            height={height}
          />
        </ListWrapper>
        {form}
      </div>
    );
  }
}
